<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2>{{ id ? t('help-pages::page.title.edit_help_page') : t('help-pages::page.title.new_help_page') }}</h2>
            <v-form ref="form" v-model="isValid">
                <div class="form-wrapper">
                    <v-col cols="12" xl="10" class="px-0">
                        <v-row>
                            <v-col cols="12" lg="6" class="pb-0">
                                <v-text-field
                                    v-model="page.title"
                                    :counter="255"
                                    :error-messages="errorMessages.title"
                                    :label="`${$root.defaultMandatoryAsteriks} ${t('help-pages::create.label.title')}`"
                                    :rules="rules.title"
                                    background-color="#fff"
                                    dense
                                    outlined
                                    rounded
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="pb-0">
                                <v-switch
                                    v-model="page.is_active"
                                    :label="t('help-pages::create.label.is_active')"
                                    class="mt-0"
                                ></v-switch>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="6" class="pb-0">
                                <v-autocomplete
                                    v-model="page.acl_routes"
                                    :error-messages="errorMessages.acl_route_id"
                                    :items="locations"
                                    :label="t('help-pages::create.label.locations')"
                                    append-icon="mdi-chevron-down"
                                    :rules="rules.acl_route_id"
                                    clearable
                                    background-color="#fff"
                                    dense
                                    multiple
                                    outlined
                                    rounded
                                    required
                                    persistent-hint
                                    :hint="t('help-pages::hint.locations')"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" lg="6" class="pb-0">
                                <v-autocomplete
                                    v-model="page.roles"
                                    :error-messages="errorMessages.role_id"
                                    :items="roles"
                                    :label="t('help-pages::create.label.roles')"
                                    append-icon="mdi-chevron-down"
                                    :rules="rules.role_id"
                                    background-color="#fff"
                                    clearable
                                    dense
                                    multiple
                                    outlined
                                    rounded
                                    required
                                    persistent-hint
                                    :hint="t('help-pages::hint.roles')"
                                ></v-autocomplete>
                            </v-col>
                            <v-col :class="{ 'editor-invalid': page.content.length === 0 }" cols="12">
                                <v-label>
                                    {{ $root.defaultMandatoryAsteriks }}
                                    {{ t('help-pages::create.label.page-content') }}
                                </v-label>
                                <b-text-editor v-model="page.content" :api-key="tinymceApiKey"></b-text-editor>
                                <div v-if="!page.content.length" class="v-text-field__details">
                                    <div class="v-messages theme--light error--text">
                                        <div class="v-messages__wrapper">
                                            {{ t('default::validation.field.required') }}
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <!-- :is-disabled="!isValid || !page.content.length" -->
                    <b-form-actions
                        :id="id"
                        :back-route="$root.route('help-pages.index')"
                        :has-discard-button="false"
                        @save="saveHelpPage"
                    ></b-form-actions>
                </div>
            </v-form>
        </v-col>
    </div>
</template>
<script>
let formSubmitMixin = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/FormSubmit.js').default;

export default {
    name: 'HelpPagesDetails',
    mixins: [formSubmitMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
        tinymceApiKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isValid: true,
            loading: false,
            page: {
                content: '&nbsp;',
            },
            locations: [],
            roles: [],
            rules: {
                title: [
                    (v) => !!v || t('default::validation.field.required'),
                    (v) => (v && v.length <= 255) || t('help-pages::validation.title.max_length'),
                ],
                acl_route_id: [],
                role_id: [],
                content: [(v) => !!v || t('default::validation.field.required')],
            },

            errorMessages: {
                title: [],
                acl_route_id: [],
                role_id: [],
                content: [],
            },
        };
    },
    created() {
        this.loadHelpPage();
        this.loadLocations();
        this.loadRoles();
    },
    methods: {
        backToList() {
            return this.$root.goTo(route('help-pages.index'));
        },
        async saveHelpPage() {
            this.page.content = this.page.content === '&nbsp;' ? '' : this.page.content;
            if (this.page.id) {
                this.submit(route('api.v1.help-pages.update', { help_page: this.id }), this.page, 'put', () => {
                    this.$root.notify('info', t('default::notification.success'), t('help-pages::notification.update'));
                    _.delay(() => {
                        this.$root.goTo(route('help-pages.index'));
                    }, 1000);
                });
            } else {
                this.submit(route('api.v1.help-pages.store'), this.page, 'post', () => {
                    this.$root.notify('info', t('default::notification.success'), t('help-pages::notification.create'));
                    _.delay(() => {
                        this.$root.goTo(route('help-pages.index'));
                    }, 1000);
                });
            }
        },
        discardChanges() {
            this.loadHelpPage();
            this.$root.notify('info', t('default::notifications.changes_discarded'));
        },
        loadHelpPage() {
            if (!this.id) {
                return;
            }

            this.loading = true;

            axios
                .get(
                    route('api.v1.help-pages.show', {
                        help_page: this.id,
                        fields: 'id,acl_routes.id,roles.id,roles.name,title,content,is_active',
                    })
                )
                .then((response) => {
                    let roles = [];
                    let acl_routes = [];
                    _.each(response.data.data.roles, (role) => {
                        roles.push(role.id);
                    });

                    _.each(response.data.data.acl_routes, (route) => {
                        acl_routes.push(route.id);
                    });

                    this.page = response.data.data;
                    this.page.roles = roles;
                    this.page.acl_routes = acl_routes;

                    this.page.is_active = this.page.is_active === 1;
                    this.loading = false;
                });
        },
        loadRoles() {
            axios.get(route('api.v1.roles.options')).then((response) => {
                let roles = [];
                _.each(response.data.data, (role) => {
                    if (role.name === 'Device') {
                        return;
                    }
                    roles.push({
                        text: role.name,
                        value: role.id,
                    });
                });

                this.roles = roles;
            });
        },
        loadLocations() {
            axios
                .get(
                    route('api.v1.acl-routes.options', {
                        sort: 'full_name',
                        api_route: 0,
                        allowed_for_guests: 0,
                        method: 'GET|HEAD',
                    })
                )
                .then((response) => {
                    let locations = [];

                    _.each(response.data.data, function (location) {
                        locations.push({
                            text: location.full_name,
                            value: location.id,
                        });
                    });

                    this.locations = locations;
                });
        },
    },
};
</script>

<style scoped>
.v-btn.error {
    margin-right: 60px;
}

.editor-invalid .tox-tinymce {
    border: 2px solid #ef9a9a !important;
    border-radius: 6px;
}
</style>
